import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_add_payment_method_btn = _resolveComponent("add-payment-method-btn")!
  const _component_q_banner = _resolveComponent("q-banner")!
  const _component_show_finally = _resolveComponent("show-finally")!
  const _component_select_payment_method = _resolveComponent("select-payment-method")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_show_finally, {
      task: _ctx.task,
      loader: ""
    }, {
      default: _withCtx(() => [
        (!_ctx.paymentMethods.length)
          ? (_openBlock(), _createBlock(_component_q_banner, {
              key: 0,
              class: "bg-yellow-3",
              "inline-actions": "",
              rounded: ""
            }, {
              action: _withCtx(() => [
                _createVNode(_component_add_payment_method_btn, {
                  "customer-id": _ctx.customerId,
                  color: "white",
                  "text-color": "black",
                  onAdded: _ctx.addPaymentMethod
                }, null, 8, ["customer-id", "onAdded"])
              ]),
              default: _withCtx(() => [
                _createTextVNode(" No payment method found. ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["task"]),
    (_ctx.paymentMethods.length)
      ? (_openBlock(), _createBlock(_component_select_payment_method, {
          key: 0,
          "customer-id": _ctx.customerId,
          "model-value": _ctx.paymentMethodId,
          outlined: "",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
        }, null, 8, ["customer-id", "model-value"]))
      : _createCommentVNode("", true)
  ]))
}